import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/studentLevelEvaluations";

export default {
  async getAllOfStudent(id) {
    const response = await HTTP.get(`${RESOURCE_NAME}/student/${id}`);
    return response.data;
  },

  async get(id, options = {}) {
    return (await HTTP.get(`${RESOURCE_NAME}/${id}`, options)).data;
  },

  async save(entity) {
    if (entity.id) {
      return (await HTTP.put(`${RESOURCE_NAME}/${entity.id}`, entity)).data;
    } else {
      return (await HTTP.post(`${RESOURCE_NAME}`, entity)).data;
    }
  },
  async delete(id) {
    return await HTTP.delete(`${RESOURCE_NAME}/${id}`);
  },
};
